// Header.client.jsx (Componente dinámico)
"use client"; // Asegúrate de que esto esté al principio del archivo para indicarle a Next.js que es un componente de cliente.

import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dropdown from './Dropdown'; // Componente Dropdown

const ClientSideHeader = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Función para alternar el estado del Dropdown
  const toggleDropdown = () => {
    setIsDropdownOpen((prevState) => !prevState); // Alterna entre abrir y cerrar el dropdown
  };

  useEffect(() => {
    const dropdownButton = document.getElementById('dropdownButton');
    
    if (dropdownButton) {
      // Añadir el event listener para el botón de dropdown
      dropdownButton.addEventListener('click', toggleDropdown);
    }

    // Limpiar el event listener cuando el componente se desmonte
    return () => {
      if (dropdownButton) {
        dropdownButton.removeEventListener('click', toggleDropdown);
      }
    };
  }, []); // Solo se ejecuta una vez cuando el componente se monta

  return (
    <div>
      {/* Aquí renderizamos el Dropdown si está abierto */}
      {isDropdownOpen && <Dropdown />}
      
      {/* Botón de cambio de tema asociado al botón de dropdown */}
      
    </div>
  );
};

ClientSideHeader.propTypes = {
  theme: PropTypes.string.isRequired,
  toggleTheme: PropTypes.func.isRequired,
};

export default ClientSideHeader;




